import { Controller } from "@hotwired/stimulus";

// Supports two usage patterns:
//   Wrapper:        <div data-controller="dialog"> … <dialog data-dialog-target="dialog"> …
//   Self-contained: <dialog data-controller="dialog" data-dialog-target="dialog"> …
//
// Stimulus target lookups only search descendants, so the self-contained pattern
// can't resolve dialogTarget. We fall back to this.element when it's a <dialog>.

export default class extends Controller {
  static targets = ["dialog"];

  get dialog() {
    return this.hasDialogTarget ? this.dialogTarget : this.element;
  }

  connect() {
    // Self-contained: controller IS the <dialog>, so target callbacks won't fire
    if (!this.hasDialogTarget && this.element.tagName === "DIALOG") {
      this.element.addEventListener("close", this._onClose);
    }
  }

  disconnect() {
    if (!this.hasDialogTarget && this.element.tagName === "DIALOG") {
      this.element.removeEventListener("close", this._onClose);
    }
  }

  open() {
    if (this.dialog.open) return;
    this.dialog.showModal();
    this.dispatch("open");
  }

  close() {
    this.dialog.close();
  }

  // Close when click lands on <dialog> itself (the full-viewport transparent area),
  // not on .modal-content or its children.
  backdropClose(event) {
    if (event.target === this.dialog) this.close();
  }

  // Wrapper pattern: target lifecycle hooks for close event
  dialogTargetConnected(target) {
    target.addEventListener("close", this._onClose);
  }

  dialogTargetDisconnected(target) {
    target.removeEventListener("close", this._onClose);
  }

  _onClose = () => this.dispatch("close");
}
